// extracted by mini-css-extract-plugin
module.exports = {"containerII":"Loading_containerII__fAGaI","img":"Loading_img__2ar3c","aux":"Loading_aux__G2pFT","loading":"Loading_loading__2JaUi"};